// Tailwind config init helper.
//
// Ported from the inline <script> block in admin/index.php (lines 813-826).
// The original returns an object with a .config() method that merges user
// config over defaults, and a .theme property. The result is serialised
// onto the <html> element's data-tailwind-config attribute.

interface TailwindConfig {
  content: unknown[];
  theme: { extend: Record<string, unknown> };
  [k: string]: unknown;
}

interface TailwindInit {
  config(userConfig?: Partial<TailwindConfig>): TailwindConfig;
  theme: { extend: Record<string, unknown> };
}

export function initTailwind(): TailwindInit {
  return {
    config(userConfig: Partial<TailwindConfig> = {}): TailwindConfig {
      return {
        content: [],
        theme: { extend: {} },
        ...userConfig,
      };
    },
    theme: {
      extend: {},
    },
  };
}